import Vue from 'vue'
import { Demo }  from './components/Demo'

import './scss/main.scss';
import { SearchWidget } from './components/SearchWidget';
import { EventBus } from './services/EventBus';
import { AppService } from './services/AppService';
import * as GeoUtils from './utils/GeoUtils'
import { RandomItemsWidget } from './components/RandomItemsWidget';
import { MostRatedWidget } from './components/MostRatedWidget';
import { MostRatedSliderWidget } from './components/MostRatedSliderWidget';

Vue.config.productionTip = false


export const mount = (name: string, attachmentPoint: string, componentProps:object = {}) => {
  const inputProps = JSON.stringify(componentProps);
  const app = new Vue({
    el: `#${attachmentPoint}`,
    data: componentProps,
    propsData: componentProps,
    components: {
      Demo,
      SearchWidget,
      RandomItemsWidget,
      MostRatedWidget,
      MostRatedSliderWidget
    },
    template: `<${name} v-bind='${inputProps}' />`
  })

  return app
}

export const emitEvent = (event:string, data: any = null) => {
  if(data){
    EventBus.$emit(event, data);
  }else{
    EventBus.$emit(event);
  }

}

export const init = () => {
  return AppService.getInstance();
}
